
import { defineComponent, PropType } from 'vue'
import { ThemeType, EThemes } from './types'

export default defineComponent({
  name: 'Button',
  props: {
    theme: { type: String as PropType<ThemeType>, default: EThemes.Default },
    disabled: { type: Boolean, default: false },
  },
  emits: ['onClick'],
  setup(props, { emit }) {
    const handleClick = () => !props.disabled && emit('onClick')

    return { handleClick }
  },
})
